import getTextWidth from '@insight/toolkit-utils/lib/display/getTextWidth';

export const calculateTextByLength = ({ children, length, size, tail }) => {
  let displayedText;
  let hasHiddenText = false;

  if (children.length <= length || length < 0) {
    return { displayedText: children, hasHiddenText };
  }

  hasHiddenText = true;
  if (length - tail.length <= 0) {
    displayedText = '';
  } else {
    displayedText = children.slice(0, length - tail.length);
  }

  return { displayedText, hasHiddenText };
};

export const calculateTextByWidth = (node, { children, tail, width }) => {
  const textWidth = getTextWidth(children, node);
  let displayedText = children;
  let hasHiddenText = false;

  if (textWidth > width) {
    const tailWidth = getTextWidth(tail, node);
    let currentWidth = textWidth;
    hasHiddenText = true;

    while (currentWidth + tailWidth > width) {
      displayedText = children.slice(0, displayedText.length - 3);
      currentWidth = getTextWidth(displayedText, node);
    }
  }

  return { displayedText, hasHiddenText };
};
